'use client';

import { ChevronRight } from 'lucide-react';

type PreStartGateProps = {
	onStart: () => void;
};

export function PreStartGate({ onStart }: PreStartGateProps) {
	return (
		<div className="ai-msg-enter mb-8">
			<div className="whitespace-pre-wrap text-base leading-[1.6] text-black">
				{'Это тренировочное собеседование. У тебя будет '}
				<span className="font-semibold">45 минут</span>
				{', поставить интервью на паузу не получится. '}
				<span className="font-semibold">
					Результат повлияет на рекомендательную систему
				</span>
				{
					', поэтому важно проходить его честно.\n\nКогда будешь готов — жми «Начать», и я закреплю задание.'
				}
			</div>
			<div className="mt-3.5">
				<button
					type="button"
					onClick={onStart}
					className="inline-flex h-10 cursor-pointer items-center gap-1 rounded-lg bg-green px-5 text-sm font-medium text-white transition-colors hover:bg-green-300"
				>
					Начать <ChevronRight size={16} strokeWidth={2.5} />
				</button>
			</div>
		</div>
	);
}
